export const MIN_TEXT_WIDTH = 270;
export const MAX_INITIAL_TEXT_WIDTH = 770;
